<h2 class="title">{{ data.title }}</h2>
<div class="pre" [innerHTML]="data.description"></div>
<app-button class="link" [data]="data.link" [withArrow]="true"></app-button>